export const navLinks = [
  { id: "overview", label: "片库速览" },
  { id: "latest", label: "最新影片" },
  { id: "ranking", label: "热播榜" },
  { id: "library", label: "片库检索" },
  { id: "guide", label: "选片指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "3000+", label: "在架片目" },
  { value: "4 大", label: "内容板块" },
  { value: "每周", label: "片单更新" },
  { value: "12 个", label: "细分标签" },
];

export const overviewCards = [
  {
    key: "伦理片",
    index: "01",
    title: "伦理片",
    icon: "ri-heart-3-line",
    count: "收录 720+ 部",
    desc: "以家庭、代际、女性处境与道德选择为核心，节奏偏慢，适合愿意沉浸思考的观众。",
    points: ["亲情与代际", "现实题材", "道德困境"],
  },
  {
    key: "韩剧",
    index: "02",
    title: "韩剧",
    icon: "ri-tv-2-line",
    count: "收录 380+ 部",
    desc: "都市情感、生活流群像与治愈系成长故事为主，单集 60 分钟左右，适合连续追看。",
    points: ["都市情感", "生活群像", "治愈成长"],
  },
  {
    key: "短剧",
    index: "03",
    title: "短剧",
    icon: "ri-flashlight-line",
    count: "收录 1500+ 部",
    desc: "单集 2 分钟以内，节奏快、反转密，适合通勤或碎片时间一口气刷完一整季。",
    points: ["单集超短", "高密度反转", "通勤友好"],
  },
  {
    key: "高分电影",
    index: "04",
    title: "高分电影",
    icon: "ri-star-smile-line",
    count: "收录 640+ 部",
    desc: "站内评分 8.5 以上的口碑片单，题材横跨悬疑、公路、人文，适合想一次看个好的时候挑。",
    points: ["评分 8.5+", "口碑片单", "题材多元"],
  },
];

export const featuredFilms = [
  {
    filmId: "f08",
    kicker: "本周新上",
    title: "冬日的信",
    line: "旧邮局里的代笔人，替陌生人写，也替自己写。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20illustration%20of%20a%20snowy%20small%20town%20post%20office%20at%20dusk%2C%20warm%20amber%20lamp%20light%20through%20frosted%20windows%2C%20deep%20crimson%20and%20muted%20brown%20tones%2C%20quiet%20melancholic%20mood%2C%20painterly%20texture%2C%20editorial%20film%20poster%20art%2C%20soft%20falling%20snow%2C%20no%20text%2C%20no%20letters&width=600&height=820&seq=htys-poster-f08&orientation=portrait",
  },
  {
    filmId: "f21",
    kicker: "口碑之作",
    title: "群山回响",
    line: "两代守山人，在一座山里把话说开了。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20illustration%20of%20misty%20mountain%20ridges%20at%20golden%20hour%2C%20a%20lone%20ranger%20silhouette%20on%20a%20winding%20path%2C%20warm%20red%20and%20ochre%20sky%2C%20textured%20painterly%20brushstrokes%2C%20epic%20yet%20intimate%20mood%2C%20editorial%20film%20poster%20art%2C%20atmospheric%20haze%2C%20no%20text&width=600&height=820&seq=htys-poster-f21&orientation=portrait",
  },
  {
    filmId: "f09",
    kicker: "治愈群像",
    title: "海边的公寓",
    line: "一栋临海老公寓，七八户人家的一次停水。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20poster%20illustration%20of%20an%20old%20seaside%20apartment%20building%20at%20sunset%2C%20laundry%20swaying%20on%20balconies%2C%20amber%20and%20terracotta%20tones%2C%20gentle%20nostalgic%20mood%2C%20painterly%20textured%20style%2C%20editorial%20film%20poster%20art%2C%20soft%20ocean%20haze%2C%20no%20text&width=600&height=820&seq=htys-poster-f09&orientation=portrait",
  },
  {
    filmId: "f02",
    kicker: "催泪亲情",
    title: "母亲的账本",
    line: "一本旧账簿，写满了她从没说过的话。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20illustration%20of%20an%20open%20worn%20ledger%20book%20on%20a%20wooden%20table%20beside%20a%20cup%20of%20tea%2C%20warm%20lamp%20glow%2C%20crimson%20and%20deep%20brown%20palette%2C%20emotional%20restrained%20mood%2C%20painterly%20texture%2C%20editorial%20film%20poster%20art%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=600&height=820&seq=htys-poster-f02&orientation=portrait",
  },
  {
    filmId: "f24",
    kicker: "温柔告别",
    title: "落日俱乐部",
    line: "四位老人，一辆旧面包车，去看落日。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20road%20movie%20poster%20illustration%20of%20an%20old%20van%20driving%20toward%20a%20vast%20golden%20sunset%20on%20an%20empty%20highway%2C%20warm%20orange%20and%20crimson%20sky%2C%20dust%20in%20the%20air%2C%20painterly%20textured%20style%2C%20warm%20bittersweet%20mood%2C%20editorial%20film%20poster%20art%2C%20no%20text&width=600&height=820&seq=htys-poster-f24&orientation=portrait",
  },
  {
    filmId: "f15",
    kicker: "追剧上升",
    title: "三十秒的心动",
    line: "一场电梯故障，困住了两个人的三十秒。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20short%20drama%20poster%20illustration%20of%20two%20people%20inside%20a%20vintage%20elevator%20with%20warm%20amber%20light%2C%20crimson%20accent%20glow%2C%20playful%20tender%20mood%2C%20painterly%20textured%20style%2C%20editorial%20poster%20art%2C%20soft%20bokeh%2C%20no%20text&width=600&height=820&seq=htys-poster-f15&orientation=portrait",
  },
];

export const guideMoods = [
  {
    key: "想安静想一想",
    icon: "ri-moon-clear-line",
    desc: "适合一个人、关掉灯、慢慢看完的片子。",
    picks: ["沉默的晚餐", "第五个季节", "长夜将尽"],
    tip: "建议不倍速、不看弹幕，把台词之间的停顿也听进去。",
  },
  {
    key: "想被治愈一下",
    icon: "ri-sun-line",
    desc: "温柔、有光、看完会想给家里打个电话。",
    picks: ["冬日的信", "海边的公寓", "深夜食堂的秘密"],
    tip: "适合睡前观看，单集或单片时长控制在一小时左右最舒服。",
  },
  {
    key: "想烧脑找反转",
    icon: "ri-question-line",
    desc: "线索埋得深，结局值得回头再看一遍开头。",
    picks: ["她在五分钟后离开", "白塔之下", "虚构的证人"],
    tip: "先别看简介后半段，留白越多，反转的冲击越大。",
  },
  {
    key: "只有碎片时间",
    icon: "ri-timer-flash-line",
    desc: "单集短、能随时停下来，通勤路上就能刷。",
    picks: ["三十秒的心动", "妹妹的秘密身份", "一纸婚约"],
    tip: "短剧适合连看三到五集，一集一个钩子，不必从头追。",
  },
  {
    key: "想一起看",
    icon: "ri-group-line",
    desc: "节奏友好、话题多，适合和家人朋友边看边聊。",
    picks: ["落日俱乐部", "我们的春天", "律师的餐桌"],
    tip: "选评分 8.5 以上、争议小的片子，更容易聊得起来。",
  },
];

export const faqs = [
  {
    q: "红桃影视的最新影片一般多久更新一次？",
    a: "站内片单按板块滚动更新，通常每周集中上新一批，热播榜与「最新影片」区域会同步调整。具体到某一部的上线时间，以平台内的片目页显示为准。",
  },
  {
    q: "伦理片和普通剧情片有什么不一样？",
    a: "伦理片更强调关系与选择本身，剧情常常围绕家庭、代际、性别处境或道德困境展开，节奏偏慢，留给观众思考的空间更大。它不追求强情节，而是把人物推到必须做决定的位置上。",
  },
  {
    q: "短剧是不是都很套路，值得看吗？",
    a: "短剧的优势在于密度：单集极短、钩子密集，适合碎片时间。题材确实集中在少数几类结构上，但其中也有在反转设计和人物塑造上做得扎实的作品，可以先从站内评分较高的几部入手。",
  },
  {
    q: "高分电影的评分是怎么来的？",
    a: "站内评分综合了观众打分与观看完成度等维度形成，用于帮助筛选，不代表绝对标准。同一部片子在不同观众心里的位置本就不同，评分可以当作参考，而不是结论。",
  },
  {
    q: "热播榜是按播放量排的吗？",
    a: "热播榜主要参考近期的播放与收藏热度，并结合站内的互动数据综合排序，因此同一部片子会随着热度变化上下浮动，榜单每天都会更新。",
  },
  {
    q: "找不到想看的片子怎么办？",
    a: "可以先在「片库检索」里用关键词或标签筛选，再切换板块查看。如果仍然没有，说明该片暂未收录进示范片单，可以留意后续的更新。",
  },
];

export const libraryTags = [
  "家庭",
  "治愈",
  "悬疑",
  "都市",
  "公路",
  "群像",
  "反转",
  "怀旧",
  "女性",
  "职场",
];